// extracted by mini-css-extract-plugin
module.exports = {"general":"style_general__4Ctv-"};